import { Injectable } from "@angular/core";
import { ControlClasses } from "./text-config";

@Injectable()
export class TextEditorService {
  constructor() {}

  getRichHtml(html) {
    //console.log('INNER HTML', html);
    const node = this.giveMeClonedNode(html);
    const newNode = document.createElement("div");
    Array.from(node.childNodes).forEach((child) => {
      const cNode = <HTMLElement>child;
      if (this.checkForPersonalization(cNode)) {
        if (this.checkForRichText(cNode)) {
          if (cNode.classList.contains("ngn-personalized-payload-value")) {
            const bTag = this.getMeLastNode(cNode);
            let targetNode;
            for (let i = 0; i < cNode.children.length; i++) {
              if ((<HTMLElement>cNode.children[i]).dataset.prefix) {
                targetNode = cNode.children[i];
                break;
              }
            }
            bTag.innerHTML = (<HTMLElement>targetNode).dataset.prefix;
            newNode.appendChild(targetNode.firstElementChild);
          } else {
            newNode.appendChild(cNode.firstElementChild.firstElementChild);
          }
        } else {
          const sNode = cNode.firstElementChild;
          sNode["innerHTML"] = (<HTMLElement>(
            cNode.firstElementChild
          )).dataset.prefix;
          newNode.appendChild(sNode);
        }
      } else {
        newNode.appendChild(cNode);
      }

      // Convert RGB TO HEX for SDK
      if (this.checkForRichText(cNode)) {
        const node = this.getMeNodeWithColorOrBgColor(cNode);
        if (node && node.childNodes.length > 0) {
          node.innerHTML = this.getRichHtml(node.innerHTML);
        }
        if (node) {
          if (node.style.color) {
            newNode.innerHTML = newNode.innerHTML.replace(
              node.style.color,
              this.rgbToHex(node.style.color)
            );
          }
          if (node.style.backgroundColor) {
            newNode.innerHTML = newNode.innerHTML.replace(
              node.style.backgroundColor,
              this.rgbToHex(node.style.backgroundColor)
            );
          }
        }
      }
    });
    return newNode.innerHTML;
  }

  checkForPersonalization(node) {
    if (node.nodeType === 3) {
      return false;
    }
    return (
      node.classList.toString().indexOf("ngn-personalized-payload-value") >= 0
    );
  }

  checkForAnyChildNodes(node) {
    const newNode = document.createElement("div");
    if (node && node.childElementCount > 0) {
      const childNodes = Array.from(node.childNodes);
      for (let i = 0; i < childNodes.length; i++) {
        let colorNode = this.getMeNodeWithColorOrBgColor(
          <HTMLElement>childNodes[i]
        );
        if (colorNode) {
          if (colorNode.style.color) {
            colorNode.innerHTML = colorNode.innerHTML.replace(
              colorNode.style.color,
              this.rgbToHex(colorNode.style.color)
            );
          } else if (colorNode.style.backgroundColor) {
            colorNode.innerHTML = colorNode.innerHTML.replace(
              colorNode.style.backgroundColor,
              this.rgbToHex(colorNode.style.backgroundColor)
            );
          }
          newNode.appendChild(colorNode);
        } else {
          newNode.appendChild(<Node>childNodes[i]);
        }
      }
    }
    return newNode.innerHTML;
  }
  getMeLastNode(node) {
    //console.log('CHECK FOR LAST NODE', node);
    // if(node.innerHTML.trim() === '') {
    //     const parent = this.getMeParentWithMoreNodes(node);
    //   for(let i=0;i<parent.children.length -1;i++) {
    //     if(node == parent.children[i] || parent.children[i].innerHTML.indexOf(node.innerHTML) >=0 ) {
    //       return this.getMeLastNode(parent.children[i+1]);
    //     }
    //   }
    // };
    // if(!node.firstElementChild){
    //   return node;
    // }
    // return this.getMeLastNode(node.firstElementChild);
    let targetNode = node;
    if (targetNode.innerText.trim() == "") {
      targetNode = targetNode.parentElement;
    }
    for (let i = 0; i < targetNode.children.length; i++) {
      if (targetNode.children[i].innerText.trim().length > 0) {
        return this.getMeActualLastNode(targetNode.children[i]);
      }
    }
  }
  getMeActualLastNode(node) {
    if (!node.firstElementChild) {
      return node;
    }
    return this.getMeActualLastNode(node.firstElementChild);
  }
  getMeParentWithMoreNodes(node) {
    if (node.parentElement && node.parentElement.children.length > 1) {
      return node.parentElement;
    } else {
      return this.getMeParentWithMoreNodes(node.parentElement);
    }
  }
  getMeNodeWithColorOrBgColor(node) {
    if (
      node.nodeName === "SPAN" &&
      (node.style.color || node.style.backgroundColor)
    ) {
      return node;
    }
    if (node.firstElementChild) {
      return this.getMeLastNode(node.firstElementChild);
    } else {
      return null;
    }
  }

  checkForRichText(node: HTMLElement) {
    let found = false;
    if (node.firstChild) {
      return this.checkForRichTextElements(node);
    }
    return found;
  }

  checkForRichTextElements(node: HTMLElement) {
    let present = false;
    const classes = Object.values(ControlClasses);
    for (let i = 0; i < classes.length; i++) {
      if (node.classList.toString().indexOf(classes[i]) >= 0) {
        present = true;
        break;
      } else if (node.getElementsByClassName(classes[i]).length > 0) {
        present = true;
        break;
      } else {
        present = false;
      }
    }
    return present;
  }

  giveMeClonedNode(html) {
    const div = document.createElement("div");
    div.innerHTML = html;
    return <HTMLElement>div.cloneNode(true);
  }

  getMeFinalHtml(richHtml, personalizedHtml) {
    const richDiv = document.createElement("div");
    richDiv.innerHTML = richHtml;
    const richNodes = Array.from(richDiv.childNodes);
    const pDiv = document.createElement("div");
    pDiv.innerHTML = personalizedHtml;
    const pNodes = Array.from(pDiv.childNodes);
    let i = 0,
      j = 0;
    while (i < richNodes.length && j < pNodes.length) {
      const rNode = this.getMeLastNode(richNodes[i]);
      if (rNode.innerText && rNode.innerHTML) {
      } else {
        i++;
      }
    }
    return personalizedHtml;
  }

  rgbToHex(regb) {
    if (/^#[0-9A-F]{6}$/i.test(regb)) return regb;
    regb = regb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    return (
      "#" +
      this.giveMeHex(regb[1]) +
      this.giveMeHex(regb[2]) +
      this.giveMeHex(regb[3])
    );
  }

  giveMeHex(x) {
    return ("0" + parseInt(x).toString(16)).slice(-2);
  }

  getMeRgeb(regb) {
    if (/^#[0-9A-F]{6}$/i.test(regb)) return regb;
    let a,
      rgb = regb
        .replace(/\s/g, "")
        .match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
      alpha = ((rgb && rgb[4]) || "").trim(),
      hex = rgb
        ? (rgb[1] | (1 << 8)).toString(16).slice(1) +
          (rgb[2] | (1 << 8)).toString(16).slice(1) +
          (rgb[3] | (1 << 8)).toString(16).slice(1)
        : regb;

    if (alpha !== "") {
      a = alpha;
    } else {
      a = "01";
    }
    // multiply before convert to HEX
    a = ((a * 255) | (1 << 8)).toString(16).slice(1);
    hex = hex + a;

    return "#" + hex;
  }

  addSignToText(innerHtml: string): string {
    let string = innerHtml
      .replace("<b>", "*")
      .replace("</b>", "*")
      .replace("<i>", "_")
      .replace("</i>", "_")
      .replace("<strike>", "~")
      .replace("</strike>", "~");
    return string;
  }

  replaceSignToHtml(text: string): string {
    let htmlString = text
      .replace(/\*(.*)\*/gim, "<b>$1</b>")
      .replace(/\_(.*)\_/gim, "<i>$1</i>")
      .replace(/\~(.*)\~/gim, "<strike>$1</strike>");
    return htmlString;
  }
}
